"use client";

import { useEffect } from "react";
import { setPageStarters } from "@/lib/pageContext";

/**
 * Publishes a content page's topic + starter questions to the help assistant
 * (HelpChat picks them up for context-aware empty-state prompts). Server pages
 * render this with their already-computed FAQ so no content is duplicated.
 * Renders nothing; clears the channel on unmount.
 */
export function PageStarters({ topic, questions }: { topic: string; questions: string[] }) {
  useEffect(() => {
    setPageStarters(topic, questions);
    return () => setPageStarters(null, null);
  }, [topic, questions]);
  return null;
}
